/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InboundDocumentScreenerResult
 */
export interface InboundDocumentScreenerResult {
    /**
     * 
     */
    lead_id: string;
}

/**
 * Check if a given object implements the InboundDocumentScreenerResult interface.
 */
export function instanceOfInboundDocumentScreenerResult(value: object): value is InboundDocumentScreenerResult {
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    return true;
}

export function InboundDocumentScreenerResultFromJSON(json: any): InboundDocumentScreenerResult {
    return InboundDocumentScreenerResultFromJSONTyped(json, false);
}

export function InboundDocumentScreenerResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): InboundDocumentScreenerResult {
    if (json == null) {
        return json;
    }
    return {
        
        'lead_id': json['lead_id'],
    };
}

export function InboundDocumentScreenerResultToJSON(json: any): InboundDocumentScreenerResult {
    return InboundDocumentScreenerResultToJSONTyped(json, false);
}

export function InboundDocumentScreenerResultToJSONTyped(value?: InboundDocumentScreenerResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lead_id': value['lead_id'],
    };
}

